import {Component, DoCheck, OnInit} from '@angular/core';
import {environment} from "@env/environment";
import {versions} from "@env/versions";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"]
})
export class AppComponent implements OnInit {
  _environment: any = {};
  _build: any = {};
  showBurger: boolean = false;
  public wasInside = false;
  public text = "";

  display: boolean = false;

  constructor() {
    this._environment = environment;
    this._build = versions;
  }

  burgerTime(burgerIs?: boolean) {
    if (burgerIs) {
      this.showBurger = burgerIs;
    } else {
      this.showBurger = !this.showBurger;
    }
  }

  ngOnInit() {
  }
  
  openReferenceGuide() {
    let win = window.open("//www.douglas.co.us/documents/advanced-search-reference.pdf",
                          "_blank");
    win.focus();
  }

  showDialog() {
    this.display = true;
  }
}
